import React from 'react';
import { formatSize } from 'pano-utils';
import { LibType } from '@types';
import { LIB_SIZE_LIMIT } from '../constants';
import LibModalNavTip from '../layouts/LibModalNavTip';

function TipImage() {
  return (
    <LibModalNavTip>
      <p>格式：.jpg .png .gif 图片文件</p>
      <p>{`容量：单张不超过${formatSize(LIB_SIZE_LIMIT[LibType.image])}`}</p>
    </LibModalNavTip>
  );
}

export default TipImage;
